export default __webpack_public_path__ + "static/media/NerdEmoji.bbf177b1.webp";